export default {
    // 模式
    "common.mode.auto": "Modo de uso automático de energia produzida",
    "common.mode.economy": "Modo econômico",
    "common.mode.exigency": "Modo de emergência",
  
    // 设备
    "common.grid": "Rede elétrica",
    "common.evChargers": "Carregadores",
    "common.evCharger": "Carregador",
    "common.pv": "Energia fotovoltaica (PV)",
    "common.inverter": "Inversor",
    "common.pcs": "Inversor + bateria",
    "common.terminal": "Dispositivo terminal",
    "common.airc": "Ar-condicionado",
    "common.engine": "Motor",
    "common.battery": "Bateria",
    "common.metter": "Medidor de eletricidade",
    "common.other": "Outro",
    "common.power": "Potência",
    "common.powerTotal": "Potência total",
    "common.voltage": "Tensão",
    "common.electricity": "Energia elétrica",
    "common.current": "Corrente",
    "common.homeUsage": "Carga total da residência",
    "common.battery.power": "Potência da bateria",
  
    // 数据
    "common.noDataAvailable": "Não há dados disponíveis no momento~",
    "common.tips": "Dica",
    "common.reset": "Redefinir",
    "common.currencyUnit": "¥",
    "common.submiting": "Enviando... Por favor, aguarde...",
    "common.close": "Fechar",
    "common.from": "De",
    "common.useIn": "Para",
    "common.energyPercent": "Percentual de fluxo de energia",
    "common.dataFlow": "Fluxo de dados",
    "common.getDataIng": "Obtendo dados... Por favor, aguarde...",
    "common.pageLoading": "Carregando conteúdo da página... Por favor, aguarde...",
    "common.reseting": "Redefinindo conteúdo da página... Por favor, aguarde...",
    "common.save": "Salvar",
    "common.onlyNumberTips": "Apenas números podem ser inseridos",
    "common.offline": "Offline",
    "common.online": "Online",
    "common.fault": "Falha",
    "common.charge": "Carregar",
    "common.discharge": "Descarregar",
    "common.buy": "Comprar",
    "common.sell": "Vender",
    "common.loadingInfo": "Carregando... Por favor, aguarde...",
  
    // 通用功能
    "common.moreFeatures": "Mais funcionalidades",
    "common.confirm": "Confirmar",
    "common.saveing": "Salvando... Por favor, aguarde...",
    "common.searchPlacholder": "Insira uma palavra-chave para busca",
    "common.iSee": "Eu entendo",
    "common.pageErrorTips1": "Oh, ocorreu um erro na página~",
    "common.pageErrorTips2": "Tente atualizar a página ou entrar em contato com o suporte~",
    "common.refresh": "Atualizar",
    "common.backToHome": "Voltar para a página inicial",
    "common.checkTips": "Verificando... Por favor, aguarde...",
    "common.back": "Voltar",
    "common.cancel": "Cancelar",
    "common.optional": "Opcional",
    "common.required": "Obrigatório",
    "common.status": "Status",
    "common.statusNoDelete": "Não deletado",
    "common.statusDelete": "Deletado",
    "common.submit": "Enviar",
    "common.disable": "Desativar",
    "common.enable": "Ativar",
    "common.year": "ano",
    "common.month": "mês",
    "common.day": "dia",
    "common.version": "Versão:",
    "common.backHome": " Voltar para a página inicial",
    "common.backHomeSorry": "Desculpe, a página perdeu o caminho acidentalmente",
    "common.requestTips1": "Processamento de dados em andamento, não envie novamente",
    "common.requestTips2": "Notificações do sistema",
    "common.requestTips3": "A sessão expirou, por favor, faça login novamente",
    "common.requestTips4": "Fazer login novamente",
    "common.requestTips5": "Sessão inválida ou expirada, por favor, faça login novamente.",
    "common.requestTips6": "Erro no servidor, por favor tente novamente mais tarde.",
    "common.requestTips7": "O tempo de solicitação da interface do sistema expirou",
    "common.requestTips8": "Interface do sistema",
    "common.requestTips9": "Erro",
    "common.iknow": "Eu entendo",
    "common.logoutSuccess": "Logout bem-sucedido",
    
    // 了解更多组件
    "common.knowMore.title": "Para obter mais informações, entre em contato com a Beineng",
    "common.knowMore.email": "E-mail para contato",
    "common.knowMore.phone": "Telefone para contato",
    "common.knowMore.wechat": "WeChat para contato",
    "common.knowMore.website": "Endereço do site oficial",
    "common.knowMore.address": "Endereço para contato",
    "common.knowMore.addressDetail": "Apartamentos 1205, 1301, Edifício 5, Rua Qinghe nº 8, Vila Huangjingkeng, Distrito Huangjiang, Cidade Dongguan, Província de Guangdong",
    
    // 本地连接组件
    "common.localConnection": "Conexão local",
    "common.operateInApp": "Realize a operação no aplicativo!",
    
    "common.enbleStaus": "Status de ativação",
    "common.battery.status": "Sem carregamento e descarregamento",
  
    // 账户相关
    "account.forgetThePassword": "Esqueci a senha",
    "account.logInDirectly": "Fazer login diretamente",
    "account.tips1": "Redirecionando para a página... Por favor, aguarde...",
    "account.tips2": "Primeiro, leia e aceite os termos de uso!",
    "account.autoLogin": "Login automático",
    "account.userLogin": "Login do usuário",
    "account.registerTips": "Ainda não tem uma conta? Clique aqui para se cadastrar",
    "account.userEmail": "Nome de usuário / E-mail",
    "account.userEmailTips": "Insira o nome de usuário ou e-mail",
    "account.password": "Senha",
    "account.passwordTips": "Insira a senha",
    "account.submit": "Enviar",
    "account.submitTips": "Enviando... Por favor, aguarde...",
    "account.otherLoginTips": "Ou selecione outro método de login",
    "account.userRegistration": "Cadastro de usuário",
    "account.userName": "Nome de usuário",
    "account.userNameTips": "Insira o nome de usuário",
    "account.emailTips1": "Insira o endereço de e-mail",
    "account.emailTips2": "Formato de e-mail inválido",
    "account.phone": "Número de telefone",
    "account.phoneTips1": "Insira o número de telefone",
    "account.phoneTips2": "Número de telefone inválido",
    "account.phoneTips3": "Insira o número de telefone",
    "account.passwordTips1": "Insira a senha (6-30 caracteres)",
    "account.passwordTips2": "Formato de senha inválido: a senha deve conter letras inglesas, números, sublinhados, traços e pontos, com comprimento de 6-12 caracteres",
    "account.passwordTips3": "As duas senhas inseridas não coincidem, por favor, verifique e insira novamente!",
    "account.passwordTips4": "Insira a senha: a senha deve conter letras inglesas, números, sublinhados, traços e pontos",
    "account.passwordTips5": "Confirmação de senha",
    "account.passwordTips6": "Insira a confirmação de senha",
    "account.passwordTips7": "As duas senhas inseridas não coincidem, por favor, verifique e insira novamente!",
    "account.passwordTips8": "Insira a confirmação de senha",
    "account.passwordTips9": "Parabéns, cadastro bem-sucedido!",
    "account.passwordTips10": "Seu nome de usuário é:",
    "account.emailIs": "E-mail é:",
    "account.goToLoginPage": "Será redirecionado automaticamente para a página de login em s segundos",
    "account.goLogin": "Fazer login",
    "account.goRegister": "Cadastrar",
    "account.loginSuccess": "Login bem-sucedido",
    "account.email": "E-mail",
    "account.sologn": "Criamos um plano de energia personalizado para você com cuidado",
    "account.pleaseAgree": "Eu li e aceito os",
    "userAgreement.privacyPolicy": "políticas de privacidade",
  
    // 验证码相关
    "account.code": "Código de verificação",
    "account.codeTips": "Insira o código de verificação",
    "account.codeTips2": "Código de verificação inválido",

    "account.inviteCodeTips": "Por favor, insira o código de convite",
    "account.inviteCodeHint": "Entre em contato com o instalador ou a equipe de operação e manutenção para obter o código de convite",  
    // 密码修改与恢复
    "account.modifyPasswordByAccount": "Alterar senha por meio da conta",
    "account.modifyPasswordByEmail": "Alterar senha por meio de e-mail",
    "account.getPasswordByAccount": "Recuperar senha por meio da conta",
    "account.getPasswordByEmail": "Recuperar senha por meio de e-mail",
  
    "account.sendEmailTips": "O código de verificação foi enviado para o e-mail, por favor, verifique",
    "account.name": "Nome da conta",
    "account.newPassword": "Nova senha",
    "account.confirmNewPassword": "Confirmação da nova senha",
    "account.nameTips": "Insira o nome da conta",
    "account.passwordModifySuccess": "Senha alterada com sucesso",
    "account.emailCode": "Código de verificação de e-mail",
    "account.emailCodeTips": "Insira o código de verificação de e-mail",
    "account.emailCodeTips2": "Código de verificação de e-mail inválido",
    "account.emailModifySuccess": "Senha alterada com sucesso",
    "account.passworTips1": "Sua senha foi redefinida com sucesso!",
    "account.passwordTips11": "Insira a confirmação de senha",
    "account.passwordTips12": "Insira a nova senha",
    "account.nickname": "Apelido do usuário",
    "account.modifyNickname": "Alterar apelido do usuário",
    "account.modifyNicknameSuccess": "Apelido do usuário alterado com sucesso!",
    "account.nicknameTips": "Insira o apelido do usuário",
    "account.nicknameError": "Falha ao alterar o apelido do usuário!",
  
    // 快速注册与登录
    "account.login": "Fazer login",
    "account.quickRegister": "Cadastro rápido",
    "account.sendCode": "Obter código",
    "account.sendTips": "Pode enviar novamente em s segundos",
    "account.sendEmailIng": "Enviando e-mail... Por favor, aguarde...",
    "account.emailNotEmpty": "O endereço de e-mail não pode estar vazio",
    "account.registerAccount": "Cadastro de conta",
    "account.registerWelcome": "Bem-vindo ao cadastro da SusprSafe",
    "account.usernameLimit": "O nome de usuário deve começar com uma letra e só pode conter letras, números e sublinhados, com comprimento de 5-15 caracteres",
  
    // 版权信息
    "copyright.desc2": "Informações de registro do site: Registro ICP da Província de Guangdong nº 2021169764",
  
    // 用户信息编辑
    "editUserInfo.editUserInformation": "Editar informações do usuário",
    "editUserInfo.modifyUsername": "Alterar nome de usuário",
    "editUserInfo.changePictures": "Alterar foto de perfil",
    "editUserInfo.savePicturesSuccess": "Foto de perfil do usuário salva com sucesso",
    "editUserInfo.saveError": "Falha ao salvar",
    "editUserInfo.pictureLimit": "O tamanho da imagem deve ser menor que 2 MB",
    "editUserInfo.uploadPicture": "Carregar foto de perfil",
    "editUserInfo.picturePreview": "Pré-visualização",
    
    "editUserInfo.bindPhoneNumber": "Vincular número de telefone",
    "editUserInfo.bindEmail": "Vincular e-mail",
    "editUserInfo.changePassword": "Alterar senha",
  
    "editUserInfo.notificationSettings": "Configurações de notificação",
    "editUserInfo.editAccount": "Editar informações da conta do usuário",
    "editUserInfo.waitBingting": "Vinculando... Por favor, aguarde...",
    "editUserInfo.collapse": "Recolher",
    "editUserInfo.modifyBinding": "Alterar vinculação",
    
    "editUserInfo.emailAddress": "Endereço de e-mail",
    "editUserInfo.tips1": "E-mail vinculado com sucesso",
    "editUserInfo.tips2": "Falha ao salvar",
    "editUserInfo.tips3": "Enviando código de verificação de e-mail... Por favor, aguarde...",
    "editUserInfo.tips4": "O código de verificação foi enviado para o e-mail xxxx, por favor, verifique",
    "editUserInfo.tips5": "Falha ao enviar o código de verificação!",
    "editUserInfo.tips6": "O número de telefone já está vinculado",
    "editUserInfo.tips7": "O e-mail já está vinculado",
    "editUserInfo.emailTips1": "Insira o endereço de e-mail",
    "editUserInfo.emailTips2": "Formato de e-mail inválido",
    "editUserInfo.emailTips3": "Pode enviar novamente em xxxx segundos",
    "editUserInfo.emailTips4": "Obter código",
    "editUserInfo.emailTips5": "O código de verificação de e-mail não pode estar vazio",
    "editUserInfo.emailTips6": "Código de verificação de e-mail inválido",
    "editUserInfo.emailCode": "Código de verificação de e-mail",
    "editUserInfo.save": "Salvar",
  
    // 手机绑定相关
    "editUserInfo.phoneTips1": "Número de telefone vinculado com sucesso",
    "editUserInfo.phoneTips2": "Enviando código de verificação por SMS... Por favor, aguarde...",
    "editUserInfo.phoneTips3": "O código de verificação por SMS foi enviado para o número xxxx, por favor, verifique",
    "editUserInfo.phoneTips4": "Falha ao enviar o código de verificação por SMS!",
    "editUserInfo.phoneTips5": "Insira o número de telefone",
    "editUserInfo.phoneTips6": "Formato de número de telefone inválido",
    "editUserInfo.phoneTips7": "Obter código por SMS",
    "editUserInfo.phoneTips8": "Código de verificação por SMS",
    "editUserInfo.phoneTips9": "O código de verificação por SMS não pode estar vazio",
    "editUserInfo.phoneTips10": "Código de verificação por SMS inválido",
    "editUserInfo.phone": "Número de telefone",
  
  
    // 通知设置
    "editUserInfo.noticeTips1": "Falha ao obter as configurações de notificação!",
    "editUserInfo.noticeTips2": "Configurações de notificação salvas com sucesso!",
    "editUserInfo.noticeTips3": "Notificação de nível baixo de bateria",
    "editUserInfo.noticeTips4": "Notificação de conclusão de carregamento do carregador",
    "editUserInfo.errorNotification": "Notificação de erro",
    "editUserInfo.updateNotification": "Notificação de atualização",
    "editUserInfo.monthlyStatisticsNotification": "Notificação de estatísticas mensais",
    "editUserInfo.notificationMethod": "Método de recebimento",
  
    // 用户名相关提示
    "editUserInfo.userNameTips1": "Nome de usuário salvo com sucesso",
    "editUserInfo.userNameTips2": "Falha ao salvar o nome de usuário",
    "editUserInfo.userNameTips3": "Insira o nome de usuário",
    "editUserInfo.userNameTips4": "Formato de nome de usuário inválido: só pode conter números, sublinhados e letras inglesas",
    "editUserInfo.userNameTips5": "Insira o nome de usuário",
    "editUserInfo.userNameTips6": "Salvando... Por favor, aguarde...",
    "editUserInfo.userName": "Nome de usuário",
  
    // 头像编辑提示
    "editUserInfo.avatorTips": "Clique para alterar a foto de perfil",
    "editUserInfo.verifyCodeTips1": "Insira o código de verificação recebido:",
    "editUserInfo.verifyCodeTips2": "Para a segurança da sua conta, clique no botão abaixo para enviar o código de verificação para o número de telefone original:",
    "editUserInfo.verifyCodeTips3": "Obter código",
    "editUserInfo.verifyCodeTips4": "Verificação do número de telefone original bem-sucedida, insira o novo número de telefone vinculado",
    "editUserInfo.verifyCodeTips5": "Para a segurança da sua conta, clique no botão abaixo para enviar o código de verificação para o e-mail original:",
    "editUserInfo.verifyCodeTips6": "Verificação do e-mail original bem-sucedida, insira o novo e-mail",
    "editUserInfo.verifyCodeTips7": "Senha antiga",
    "editUserInfo.verifyCodeTips8": "Primeiro, vincule o e-mail!",
    "editUserInfo.verifyCodeTips9": "O código de verificação foi enviado para o e-mail, por favor, verifique",
    "editUserInfo.verifyCodeTips10": ", será redirecionado automaticamente para a página de login",
  
    // 通知相关
    "hems.notice.title": "Título da notificação", 
    "hems.notice.content": "Conteúdo da notificação", 
    "hems.notice.operate": "Operação",
    "hems.notice.noRead": "Não lido",
    "hems.notice.read": "Lido",
    "hems.notice.warning": "Aviso",
    "hems.notice.error": "Erro",
    "hems.notice.success": "Cálculo de estatísticas",
    "hems.notice.sys": "Informações do sistema",
    "hems.notice.operateSuccess": "Operação bem-sucedida",
    "hems.notice.operateTips": "Selecione o item para operar",
  
    // 首页
    "hems.home.selfuseRate": "Taxa de uso próprio",
    "hems.home.percent": "Percentual",
    "hems.home.todayData": "Dados de hoje",
    "hems.home.todayPowerGeneration": "Produção de energia de hoje",
    "hems.home.salesIncome": "Renda da venda de energia",
    "hems.home.saved": "Você economizou",
    "hems.home.reduce": "Reduzir a pegada de carbono",
    "hems.home.tips1": "Não há dados disponíveis no momento, você ainda não vinculou o xxxx",
    "hems.home.criticalLoad": "Carga crítica",
    "hems.home.keyVoltage": "Tensão crítica",
    "hems.home.householdLoad": "Carga residencial",
    "hems.home.householdVoltage": "Tensão residencial",
    "hems.home.generalLoad": "Carga geral",
    "hems.home.generalVoltage": "Tensão geral",
    "hems.home.batteryHealth": "Status de saúde da bateria",
    "hems.home.averageTemp": "Temperatura média",
    "hems.home.gridLoad": "Carga da rede elétrica",
    "hems.home.toggeleDataSource": "Os dados exibidos foram alterados para:",
    "hems.home.toggleTips": "Tem certeza que deseja alterar?",
    "hems.home.modeSending": "Enviando comando de modo... Por favor, aguarde...",
    "hems.home.modeSuccess": "Comando de alteração de modo enviado com sucesso!",
    "hems.home.isOnline": "Está online?",
    "hems.home.useStatus": "Status de uso",
    "hems.home.workModeText": "Modo de trabalho atual:",
    "hems.home.toggleDataSourceText": "Os dados exibidos foram alterados para:",
    "hems.ev.charge.status": "Status de carregamento",
    "hems.ev.charge.time": "Tempo de carregamento",
    "hems.ev.charge.count": "Quantidade de carregamento em tempo real",
    "hems.ev.charge.status.empty": "Vazio",
    "hems.ev.charge.status.ing": "Carregando com cabo conectado",
    "hems.ev.charge.status.null": "Cabo conectado, mas sem carregamento",
    "hems.ev.charge.status.error": "Erro",
    "hems.hour": "hora",
    "hems.minue": "minuto",
    "hems.ev.chagre.number": "Número do carregador",
  
    // 用户指南
    "hems.userGuide.selfUse": "Uso próprio de energia produzida",
    "hems.userGuide.selfUseTips": "Primeiro, use a energia fotovoltaica; se não for suficiente, complemente com a rede elétrica",
    "hems.userGuide.economyMode": "Modo econômico",
    "hems.userGuide.economyModeTips": "Otimizar a estratégia de uso de energia de acordo com o preço da energia elétrica",
    "hems.userGuide.emergencyMode": "Modo de emergência",
    "hems.userGuide.emergencyModeTips": "Priorizar o fornecimento de energia para a carga crítica primeiro",
  
    // 图表页面
    "hems.history.energyStatistics": "Estatísticas de energia",
    "hems.history.revenueStatistics": "Estatísticas de receita",
    "hems.history.greenStatistics": "Redução de emissões verdes",
    "hems.history.revenueTitle": "Receita total da venda de energia",
    "hems.history.savingsTitle": "Economia total",
    "hems.history.carbonTitle": "Redução total de carbono",
    "hems.history.day": "dia",
    "hems.history.month": "mês",
    "hems.history.year": "ano",
    "hems.history.beforeDay": "Dia anterior",
    "hems.history.afterDay": "Próximo dia",
    "hems.history.beforeMonth": "Mês anterior",
    "hems.history.afterMonth": "Próximo mês",
    "hems.history.beforeYear": "Ano anterior",
    "hems.history.afterYear": "Próximo ano",
    "hems.history.totalUse": "Uso total",
    "hems.history.fullScreen": "Tela cheia",
    "hems.history.timeSelect": "Selecionar data",
    "sync.tips1": "Comando de sincronização de dados enviado com sucesso!",
    "sync.tips2": "Sincronização de dados em andamento; devido ao grande volume de dados, é necessário tempo, verifique novamente após meia hora~",
    "sync.tips3": "A sincronização de dados do dispositivo pode ter atraso; se você notar inconsistência nos dados, clique em:",
    "sync.tips4": "Sincronizar dados",
  
    // 充电桩信息
    "charge.info": "Informações do carregador",
    "news.loading": "Carregando...",
    "news.noMore": "Não há mais dados",
    "hems.pv.power": "Quantidade de energia fotovoltaica",
  
    // UEH特定功能
    "ueh.sellPower": "Quantidade de energia vendida",
    
    // 菜单
    "menu.home": "Página inicial",
    "menu.history": "Dados históricos",
    "menu.device": "Dispositivos",
    "menu.settings": "Configurações",
    "menu.messageCenter": "Centro de mensagens",
    "menu.help": "Ajuda e suporte",
    "menu.mine": "Meu",
  
  
    // 我的设置
    "mine.userSetting": "Configurações do usuário",
    "mine.terminalSetting": "Configurações básicas do terminal",
    "mine.uploadCloud": "Carregar dados para a nuvem",
    "mine.changeVersion": "Verificar atualização",
    "mine.language": "Alterar idioma",
    "mine.about": "Sobre o aplicativo",
    "mine.feedback": "Feedback",
    "mine.logout": "Sair",
    "mine.logoutAccount": "Excluir conta",
  
    // 注销账户相关
    "mine.logoutAccountTips": "Excluir conta com nome []",
    "mine.logoutAccountTips1": "Excluir conta vinculada a []",
    "mine.logoutAccountCare": "Notas sobre a solicitação de exclusão de conta:",
    "mine.logoutAccountCare1": "1. A conta está em status seguro",
    "mine.logoutAccountCare1-1": "A conta está em modo de uso normal, sem risco de furto, violação de regras ou bloqueio.",
    "mine.logoutAccountCare2": "2. Autorizações e vinculações da conta foram removidas",
    "mine.logoutAccountCare2-1": "Todas as autorizações da conta com plataformas de terceiros foram removidas.",
    "mine.logoutAccountCare3": "3. Após a exclusão, a conta não pode ser recuperada e os dados do usuário serão deletados",
    "mine.logoutAccountCare3-1": "Após a exclusão, os números de telefone vinculados, e-mails e outros dados serão deletados e não podem ser recuperados.",
    "mine.confirmLogout": "Confirmar exclusão",
    "mine.logoutSuccess": "Conta excluída com sucesso!",
  
  
    // 反馈问题
    "mine.feedbackIssues": "Feedback sobre problemas",
    "mine.feedQuantity": "Quantidade",
    "mine.feedAmount": "Máximo de 9 imagens, tamanho máximo de 1 MB por imagem",
  
    // 通知设置相关
    "mine.notice.fail": "Falha ao obter as configurações de notificação!",
    "mine.notice.saveSuccess": "Configurações de notificação salvas com sucesso!",
    "mine.notice.saveFail": "Falha ao salvar!",
    "mine.notice.title": "Configurações de notificação",
    "mine.notice.batteryLow": "Notificação de nível baixo de bateria",
    "mine.notice.chargingFinish": "Notificação de conclusão de carregamento do carregador",
    "mine.notice.error": "Notificação de erro",
    "mine.notice.update": "Notificação de atualização",
    "mine.notice.monthly": "Notificação de estatísticas mensais",
    "mine.notice.receiveType": "Método de recebimento",
  
    // 语言设置欢迎语
    "mine.language.welcome": "Bem-vindo à SusprSafe",
    "mine.language.desc1": "Selecione a versão do idioma de acordo com o seu local de residência",
    "mine.language.desc2": "Você pode alterá-lo a qualquer momento nas configurações do aplicativo",
  
    // 个人信息
    "mine.userInfo.avatar": "Foto de perfil",
    "mine.userInfo.nickname": "Apelido",
    "mine.userInfo.password": "Senha",
    "mine.userInfo.changePassword": "Alterar senha",
    "mine.userInfo.setPassword": "Definir senha",
    "mine.userInfo.phoneNumber": "Número de telefone",
    "mine.userInfo.bindPhone": "Vincular número de telefone",
    "mine.userInfo.bindEmail": "Vincular e-mail",
    "mine.loginExpired": "A sessão expirou, por favor, faça login novamente",
    "mine.userInfo.title": "Informações do usuário",
    "mine.userInfo.bind": "Vincular",
    "mine.userInfo.modify": "Editar",
    "mine.userInfo.modifyNickname": "Alterar apelido",
    "mine.userInfo.userNickname": "Apelido do usuário",
    "mine.userInfo.selectPic": "Selecione uma imagem para carregar",
    "mine.userInfo.saveSuccess": "Salvo com sucesso",
    "mine.userInfo.uploadFail": "Falha ao carregar",
    "mine.userInfo.avatarSaveSuccess": "Foto de perfil salva com sucesso",
    "mine.userInfo.nameTips1": "O apelido do usuário não pode estar vazio",
    "mine.userInfo.nameTips2": "Insira o apelido do usuário",
  
    // 通用选择提示
    "common.pleaseSelect": "Por favor, selecione",
    "question.commonQuestions": "Perguntas frequentes",
    "account.toggleLanguage": "Alterar idioma",
    "account.localConnection": "Conexão local",
    "account.selectLanguage": "Por favor, selecione o idioma",
    "account.sendEmailToast": "O código de verificação foi enviado para o e-mail xxx, por favor, verifique",
    "account.emailError": "Formato de e-mail inválido",
    "account.sendEmailFail": "Falha ao enviar, por favor, tente novamente",
    
    "common.submitting": "Enviando... Por favor, aguarde...",
  
    "device.page.noData": "Não há dados disponíveis no momento; esta página só pode ser visualizada no aplicativo"
  ,

  // OTA Upgrade
  "bmsFirmware.upgrade": "Atualizar",
  "bmsFirmware.upgrading": "Atualizando...",
  "bmsFirmware.uploadingFile": "Enviando arquivo de firmware...",
  "bmsFirmware.upgradingProgress": "Atualizando firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Atualização bem-sucedida",
  "bmsFirmware.upgradeSuccessSubtitle": "Atualização do firmware BMS concluída!",
  "bmsFirmware.upgradeFailed": "Falha na atualização",
  "bmsFirmware.upgradeFailedFormError": "Verifique se o formulário está preenchido corretamente",
  "bmsFirmware.upgradeFailedNetworkError": "Erro de rede, tente novamente",
  "bmsFirmware.invalidFileType": "Selecione um arquivo de firmware válido (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Selecione primeiro um arquivo de firmware",
  "bmsFirmware.statusUpgrading": "Atualizando",
  "bmsFirmware.statusCompleted": "Atualização concluída",
  "bmsFirmware.statusFailed": "Falha na atualização",
  "bmsFirmware.deviceUpgrading": "Atualizando pacote de firmware, a atualização leva de 30 a 50 minutos, os dados do dispositivo em tempo real não podem ser visualizados durante este período, aguarde...",
  "bmsFirmware.upgradeStatusLabel": "Status da atualização",
  "bmsFirmware.upgradeProgressLabel": "Progresso da atualização",
  "bmsFirmware.currentPackageLabel": "Número do pacote de dados transmitido atualmente",
  "bmsFirmware.totalPackagesLabel": "Número total de pacotes de dados",
  "bmsFirmware.upgradeFailedCheckDevice": "Verifique o status do dispositivo e tente a atualização novamente",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Configuração bem-sucedida",
  "settingResult.defaultSubTitle": "Configurações de parâmetros salvas",
  "settingResult.confirmButton": "OK"
};